module.exports = __webpack_public_path__ + "static/media/react.5d5d9eef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/react-logo/react.svg
// module id = 919
// module chunks = 0